// imports
import * as THREE from "three"
import { Pane } from "tweakpane";
import Stats from "stats.js";

// classes
import Experience from "../Experience";

export default class Debug
{
    constructor() 
    {
        // setup
        this.experience = new Experience()
        this.app = this.experience.app
        this.scene = this.experience.scene

        // options
        this.active = window.location.hash === "#debug"
        
        if ( this.active )
        {
            this.ui = new Pane( 
            {
                title: "Scene analyzer",
                expanded: true
            } )
        }
    }

    setHelpers()
    {
        this.terrain = this.experience.world.terrain
        this.stats = new Stats()
        this.stats.showPanel( 0 )
        this.app.appendChild( this.stats.dom )

        this.gridParameters =
        {
           status: true,
           gridSize: this.terrain.instance.geometry.parameters.radius * 2 ,
           gridDivisions: 50,
           axisColor: "#00FF00",
           mainColor: "#ffffff",

           position:
           {
                x: 0,
                y: 0.01,
                z: 0,

           }
        }
        this.gridHelper = new THREE.GridHelper( 
            this.gridParameters.gridSize, 
            this.gridParameters.gridDivisions, 
            this.gridParameters.axisColor, 
            this.gridParameters.mainColor 
        );
        this.gridHelper.position.set( ...Object.values( this.gridParameters.position ) )
        this.scene.add( this.gridHelper );

        this.boxParameters =
        {
            status: true,
            boxColor: "#FF0000"
        }
        this.boxHelper = new THREE.BoxHelper( this.terrain.instance, this.boxParameters.boxColor )
        this.scene.add( this.boxHelper )

        this.skeletonParameters =
        {
            status: true
        }
        this.skeletonHelper = new THREE.SkeletonHelper( this.experience.world.fox.instance )
        this.scene.add( this.skeletonHelper )

        this.setDebug()
    }

    setDebug()
    {
        this.folder = this.ui.addFolder( 
        {
            title: "Helpers",
            expanded: false
        } ).on( "change", ( _changeInfo ) => this.handleChange( _changeInfo ) )

        this.folder.addBlade( 
        {
            view: "list",
            label: "gridStatus",

            options:
            [
                { text: "On", value: true },
                { text: "Off", value: false },
            ],

            value: this.gridParameters.status
        } )
        this.folder.addBlade( 
        {
            view: "list",
            label: "boxStatus",

            options:
            [
                { text: "On", value: true },
                { text: "Off", value: false },
            ],

            value: this.boxParameters.status
        } )
        this.folder.addBlade( 
        {
            view: "list",
            label: "skeletonStatus",

            options:
            [
                { text: "On", value: true },
                { text: "Off", value: false },
            ],

            value: this.skeletonParameters.status
        } )

        this.folder.addInput( this.gridParameters, "gridSize", 
        {
            min: 0,
            max: 150,
            step: 1
        } )

        this.folder.addInput( this.gridParameters, "gridDivisions", 
        {
            min: 0,
            max: 250,
            step: 1
        } )

        this.folder.addInput( this.gridParameters, "axisColor" )
        this.folder.addInput( this.gridParameters, "mainColor" )

        this.folder.addInput( this.boxParameters, "boxColor" )
    }

    handleChange( _changeInfo )
    {
        const label = _changeInfo.target.controller_.view.labelElement.innerText

        if ( label === "gridStatus" && _changeInfo.value === false )
        {
            this.scene.remove( this.gridHelper )
            this.gridHelper.dispose()
            return
        }
        if ( label === "boxStatus" && _changeInfo.value === false )
        {
            this.scene.remove( this.boxHelper )
            this.boxHelper.dispose()
            return
        }
        if ( label === "skeletonStatus" && _changeInfo.value === false )
        {
            this.scene.remove( this.skeletonHelper )
            this.skeletonHelper.dispose()
            return
        }
        this.scene.remove( this.gridHelper )
        this.scene.remove( this.boxHelper )
        this.gridHelper.dispose()
        this.boxHelper.dispose()
        

        this.gridHelper = new THREE.GridHelper( 
            this.gridParameters.gridSize, 
            this.gridParameters.gridDivisions, 
            this.gridParameters.axisColor, 
            this.gridParameters.mainColor 
        );
        this.scene.add( this.gridHelper );

        this.boxHelper = new THREE.BoxHelper( this.terrain.instance, this.boxParameters.boxColor )
        this.scene.add( this.boxHelper )

    }
}